import {useState, useEffect} from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Box from "@mui/material/Box";

import Loading from '../../common/Loading';


export default function LoadListFilterReelTypeList(props) {
    //console.debug("RTS Break LoadListFilterReelTypeList");

    const [isLoading, setIsLoading] = useState(true);

    const [reelTypes, setReelTypes] = useState();
    const [repoReelTypes, setRepoReelTypes] = useState();


    useEffect(() => {
        if(props.reelTypes===null){
            setReelTypes([]);
        }
        else{
            setReelTypes(props.reelTypes);
        }

        if(props.data == null){
            setRepoReelTypes([]);
        }
        else{
            setRepoReelTypes(props.data);
        }

        setIsLoading(false);
    }, [props]);     


    function valChange(e, val){
        props.setReelTypesFx(val);
        setReelTypes(val);
    }    


    if(isLoading){
        return(
            <Loading />
        );
    }


    return(
        <>
            <Autocomplete
                options={repoReelTypes}
                renderInput={(params) => <TextField {...params} label="Reel Types" size="small" />}
                value={reelTypes}
                onChange={valChange}
                getOptionLabel={(reelType) => reelType.name}
                renderOption={(props, repoReelTypes) => (
                    <Box component="li" {...props} key={repoReelTypes.idGuid}>
                        {repoReelTypes.name}
                    </Box>
                )}
                multiple
            />
        </>
    );
}

